import React, { Component } from "react";
import { Row, Col, Card, Divider, Button, Input, Select, Image } from "antd";
import styled from "styled-components";
import {
  BsCalendarMinus,
  MdOutlineBusiness,
  MdContactPhone,
  MdAudiotrack,
  AiOutlinePlaySquare,
  MdNote,
  FaImages,
  BiNote,
  GrTest,
  AiFillStar,
  AiOutlineCloud,
  BsSunFill,
  AiFillCloud,
  BsCircleFill,
  BsFillCameraReelsFill,
  BsExclamationLg,
  CgCrown,
} from "react-icons/all";
import CreditCard from "../../components/EmployeCard/creditcard";
import { connect } from "react-redux";
import { DashboardAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";
import FileView from "../../components/fileView";
import Configuration from "../../assets/images/configuration.png";
import Pickup from "../../assets/images/pickup.png";
import Checklist from "../../assets/images/profile_success.png";
import LeaveSite from "../../assets/images/leavsite.png";
import DropOff from "../../assets/images/dropoff.png";
import LoaderGif from "../../assets/images/ie_loader.gif";
import Distance from "../../assets/images/distance.png";
import ReactPlayer from "react-player";
import { formatToNumber, getMiles } from "../../../plant_dir/config/utils";
import { checkUndefinedOrNull } from "../../config/utils";
import { FileOutlined } from "@ant-design/icons";
const { Option } = Select;
const OrderNumWrapper = styled(Card)`
  min-height: 250px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
`;
const { TextArea } = Input;
class LogisticsOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Notes: false,
      isOpenReject: false,
      documentModal: false,
      isTesting: false,
      distanceModal: false,
      fileDocument: false,
      testFileDocument: false,

      isOpenLogisticsNotesModal: false,
      isOpenLogisticsFileModal: false,
      isOpenLogisticsTestsModal: false,

      isDistance: false,
      isOpenViewMix: false,
      isDispatchModal: false,
      logValue: "",
      isSelect: false,
      row: 2,
      isReadMore: false,
      isOpenDeleteModal: false,
      isOpenCheckList: false,
      checkListData: [],
      listIndex: 0,
      orderViewMix: [],
      viewMixDetail: {},
      isVisible: false,
      isVisibleVideo: false,
      videoIndex: 0,
      audioIndex: 0,
      isVisibleDistance: false,
      isVisibleAudio: false,
      assestDriverId: "",
      noteShowOnModal: ""
    };
  }
  componentDidMount() {
    const {
      getLogisticDetail,
      match: {
        params: { id, orderid },
      },
    } = this.props;
    console.log("checking==>", this.props.match.params);
    getLogisticDetail(id, orderid);
  }
  onCancelModal = () => {
    this.setState({
      Notes: false,
    });
  };
  componentDidUpdate(preProps) {
    if (preProps.match.params.id !== this.props.match.params.id) {
      this.props.getLogisticDetail(this.props.match.params.id);
    }
  }
  render() {
    const { OrderDetail, approvedOrder, logistics } = this.props;
    const {
      checkListData,
      listIndex,
      checklistAction,
      isOpenCheckList,
      orderViewMix,
      viewMixDetail,
      videoIndex,
      isVisibleAudio,
      audioIndex,
    } = this.state;
    var assetsCount = 0
    const { meta_asset = {} } = OrderDetail;

    // Extracting unique ids from arr1
    let arr1Ids = OrderDetail?.driver_orders?.map(obj => obj.user.id);

    // Filtering out objects from arr2 with userable_id not present in arr1Ids
    let orderDetailDocument = OrderDetail?.order_assets?.documents?.filter(obj => !arr1Ids?.includes(obj.userable_id));
    let orderDetailTestDocument = OrderDetail?.order_assets?.test_documents?.filter(obj => !arr1Ids?.includes(obj.userable_id));
    let inputRef;
    console.log("testtt", orderDetailTestDocument);
    // const filterViewMix = (
    //   OrderDetail?.order_products?.[0]?.order_product_additives || []
    // ).filter((item) => {
    //   return item.selected;
    // });

    const filterViewMix = (orderViewMix || []).filter((item) => item.selected);

    return (
      <>
        {OrderDetail?.id ? (
          <Row justify="space-around" style={{ marginTop: "10px" }}>
            <Col xl={9} md={24} lg={10}>
              <OrderNumWrapper>
                <Row align="middle">
                  <Col xl={2} xs={4} sm={3} md={2} lg={2} xxl={2}>
                    <span
                      style={{
                        border:
                          OrderDetail?.preferred_delivery_period === "pm"
                            ? "solid grey 2px"
                            : "solid red 2px",
                        width: "25px",
                        height: "25px",
                      }}
                      className={
                        OrderDetail?.preferred_delivery_period === "pm"
                          ? " am-pm-circle text-left"
                          : " am-pm-circle text-left"
                      }
                    >
                      {OrderDetail?.preferred_delivery_period === "am" ? (
                        <BsExclamationLg color="red" size={15} />
                      ) : (
                        <BsExclamationLg color="grey" size={15} />
                      )}
                    </span>
                  </Col>
                  <Col xl={22} md={22} lg={20} xxl={20} className="text-left">
                    <h5>{`Order# ${OrderDetail?.order_number}`}</h5>
                  </Col>
                  <Col
                    xl={
                      OrderDetail?.logistics_order?.status == 1 ||
                        OrderDetail?.logistics_order?.status == 4
                        ? 4
                        : OrderDetail?.logistics_order?.status == 2 ||
                          OrderDetail?.logistics_order?.status == 5
                          ? 5
                          : 3
                    }
                    className="text-left"
                  >
                    <span
                      style={{ padding: "2px 2px" }}
                      className={
                        OrderDetail?.logistics_order?.status == 1 ||
                          OrderDetail?.logistics_order?.status === 2 ||
                          OrderDetail?.logistics_order?.status === 3 ||
                          OrderDetail?.logistics_order?.status === 4
                          ? "orange order-status-label"
                          : "green order-status-label"
                      }
                    >
                      {/* {OrderDetail?.logistics_order?.status == 1 && "PENDING"}
                  {OrderDetail?.logistics_order?.status === 2 && "Dispatched"}
                  {OrderDetail?.logistics_order?.status === 3 && "Picked"}
                  {OrderDetail?.logistics_order?.status === 4 && "Dropped"}
                  {OrderDetail?.logistics_order?.status === 5 && "Completed"} */}

                      {OrderDetail?.logistics_order?.status == 1 && "PENDING"}
                      {OrderDetail?.logistics_order?.status == 2 &&
                        "DISPATCHED"}
                      {OrderDetail?.logistics_order?.status === 3 && "PICKED"}
                      {OrderDetail?.logistics_order?.status === 4 && "DROPPED"}
                      {OrderDetail?.logistics_order?.status === 5 &&
                        "COMPLETED"}
                    </span>
                  </Col>
                  <Col
                    xl={19}
                    lg={18}
                    xxl={18}
                    md={18}
                    className="text-left"
                    style={{ marginTop: "5px" }}
                  >
                    <span style={{ paddingRight: "5px" }}>
                      <BsCalendarMinus size="13" color="grey" />
                    </span>
                    <span style={{ color: "#9e9e9e" }}>
                      {moment(OrderDetail?.preferred_delivery_datetime).format(
                        "LL"
                      )}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} style={{ marginTop: "1rem" }}>
                    {!!OrderDetail?.order_dispatch_details?.length &&
                      (OrderDetail?.order_dispatch_details || []).map(
                        (item) => {
                          return (
                            <Row
                              align="middle"
                              style={{
                                background:
                                  item.action === "pick_order"
                                    ? "#eaebed"
                                    : item.action === "drop_order"
                                      ? "#f0f1f3"
                                      : "#f7f8fa",
                                padding: "1rem",
                              }}
                            >
                              <Col style={{ height: "55px" }} span={24}>
                                <Row>
                                  <Col span={4} className="text-left">
                                    <img
                                      src={
                                        item.action === "pick_order"
                                          ? Pickup
                                          : item.action === "drop_order"
                                            ? DropOff
                                            : LeaveSite
                                      }
                                    />
                                  </Col>
                                  <Col span={10} className="text-left">
                                    <h3>
                                      {item.action === "pick_order"
                                        ? "Pickup from Plant"
                                        : item.action === "drop_order"
                                          ? "Dropoff at Site"
                                          : "Leaving Site"}
                                    </h3>
                                    <p className="text-left">
                                      {moment(item?.data?.datetime).format(
                                        "MM-DD-YYYY hh:mm:ss"
                                      )}
                                    </p>
                                  </Col>
                                  <Col span={4} className="text-left">
                                    <img
                                      src={Checklist}
                                      height={"35"}
                                      width={"30"}
                                    />
                                    <p
                                      className="checklist-color pointer-cursor"
                                      style={{ fontSize: "12px" }}
                                      onClick={() => {
                                        this.setState({
                                          isOpenCheckList: true,
                                          checkListData: item?.data?.checklist,
                                          listIndex: 0,
                                          checklistAction: item?.action,
                                        });
                                      }}
                                    >
                                      Checklist
                                    </p>
                                  </Col>
                                  <Col span={2} className="m-auto">
                                    {item.action === "pick_order" ? (
                                      <AiOutlineCloud
                                        size={"30"}
                                        color="grey"
                                      />
                                    ) : item.action === "drop_order" ? (
                                      <BsSunFill size={"30"} color="grey" />
                                    ) : (
                                      <AiFillCloud size={"30"} color="grey" />
                                    )}
                                  </Col>
                                  <Col span={4} className="m-auto">
                                    <span>
                                      {item.data?.currently?.temperature ?

                                        `${Math.round(
                                          item.data?.currently?.temperature
                                        )} °F`
                                        :
                                        "_"
                                      }

                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          );
                        }
                      )}
                  </Col>
                </Row>
                <Row>
                  <Col span={24}></Col>
                  <Divider />
                </Row>

                {/* logistics asstes will show here */}
                <Row
                  style={{
                    paddingBottom: "10px",
                    paddingTop: "10px",
                    borderBottom: "1px solid #d0d0d0 ",
                    alignItems: "baseline"

                  }}
                >
                  <Col span={24}>
                    <Row>
                      <Col span={16} className="text-left" style={{ paddingTop: "25px" }}>
                        <h5 className="text-left">Order Assets</h5>
                      </Col>
                      {/* <Col>
                        <Row style={{ display: "inline" }}>
                          <Col
                            className="contractor-avatar pointer-cursor text-center"
                            style={{ background: "#4CAF50" }}
                          >
                            <FileOutlined
                              color="white"
                              size="20"
                              onClick={() => {
                                if (OrderDetail?.note) {
                                  this.setState({
                                    // assestDriverId: item?.user.id,
                                    isOpenLogisticsNotesModal: true
                                  });
                                }
                              }}
                            />
                          </Col>
                          <Col className="pointer-cursor text-center"
                            onClick={() => {
                              if (OrderDetail?.note) {
                                this.setState({
                                  // assestDriverId: item?.user.id,
                                  isOpenLogisticsNotesModal: true
                                });
                              }
                            }}
                          >
                            <small
                              className="small"
                            >
                              {OrderDetail.note ? 1 : 0} Notes
                            </small>

                          </Col>
                        </Row>
                      </Col> */}
                      <Col
                        span={4}
                        style={{ paddingTop: "12px" }}
                        className="text-left"
                      >
                        <Col>

                          <Row style={{ display: "inline" }}>
                            <Col
                              className="contractor-avatar pointer-cursor text-center"
                              style={{ background: "#FF9F00" }}
                            >
                              <BiNote
                                color="white"
                                size="20"
                                onClick={() =>
                                  this.setState({
                                    isOpenLogisticsFileModal: true,
                                  })
                                }
                              />
                            </Col>
                            <Col
                              className="pointer-cursor"
                              onClick={() =>
                                this.setState({
                                  isOpenLogisticsFileModal: true,
                                })
                              }
                            >
                              <small className="small" style={{ paddingLeft: "0.3rem" }}>
                                {orderDetailDocument?.length} Files
                              </small>
                            </Col>
                          </Row>

                        </Col>
                      </Col>
                      <Col
                        span={3}
                        style={{ paddingTop: "12px" }}
                        className="text-left"
                      >
                        <Col>
                          <Row style={{ display: "inline" }}>
                            <Col
                              className="contractor-avatar pointer-cursor"
                              style={{ background: "#01D1FE" }}
                            >
                              <GrTest
                                color="white"
                                size="20"
                                onClick={() =>
                                  this.setState({
                                    isOpenLogisticsTestsModal: true,
                                    isTesting: true,
                                  })
                                }
                              />
                            </Col>
                            <Col
                              className="pointer-cursor"
                              onClick={() =>
                                this.setState({
                                  isOpenLogisticsTestsModal: true,
                                  isTesting: true,
                                })
                              }
                            >
                              <small className="small" >
                                {orderDetailTestDocument?.length} Testing
                              </small>
                            </Col>
                          </Row>
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xl={24}></Col>
                  <Divider />
                </Row>

                <Row>
                  <Col>
                    <h6 class="ordercsh">Plant Info</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="plant-avatar">
                    <MdOutlineBusiness size="20" color="white" />
                  </Col>
                  <Col xl={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "18px" }}
                    >
                      {/* {`${OrderDetail?.rmx_company?.business_name}`} */}
                    </h5>
                    <p
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "18px" }}
                    >
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.rmx_company?.business_name}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.rmx_company?.email}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.rmx_company?.address}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.rmx_company?.phone}`}
                      </small>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xl={24}></Col>
                  <Divider />
                </Row>
                <Row>
                  <Col>
                    <h6 class="ordercsh">Contractor Info</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="contractor-avatar">
                    <MdOutlineBusiness size="20" color="white" />
                  </Col>
                  <Col span={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "18px" }}
                    >
                      {`${OrderDetail?.contractor?.user?.first_name} ${OrderDetail?.contractor?.user?.last_name}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.contractor?.user?.email}`}
                      </small>
                      <br></br>
                      {/* <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.contractor?.user?.address ? OrderDetail?.contractor?.user?.address : '-'}`}
                      </small>
                      <br></br> */}
                      <small style={{ fontSize: "90%" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.contractor?.user?.phone
                        ))}`}
                      </small>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xl={24}></Col>
                  <Divider />
                </Row>
                <Row>
                  <Col>
                    <h6 class="ordercsh">Shipping Address</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="contractor-avatar">
                    <MdContactPhone size="20" color="white" />
                  </Col>
                  <Col span={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "16px" }}
                    >
                      {`${OrderDetail?.order_addresses?.[1]?.contractors_address?.name ? OrderDetail?.order_addresses?.[1]?.contractors_address?.name : "-"}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.order_addresses?.[1]?.contractors_address?.contact_person ? OrderDetail?.order_addresses?.[1]?.contractors_address?.contact_person : "-"}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[1]?.contractors_address?.address)}`}
                        {/* {`${}`} */}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.order_addresses?.[1]?.contractors_address
                            ?.phone
                        ))}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[1]?.contractors_address?.email)}`}
                        {/* {`${}`} */}
                      </small>
                    </p>
                  </Col>
                </Row>


                <Row>
                  <Col span={24} className="text-left">
                    <h6 class="ordercsh">Billing Address</h6>
                  </Col>
                </Row>
                <Row>
                  <Col className="contractor-avatar">
                    <MdContactPhone size="20" color="white" />
                  </Col>
                  <Col span={20}>
                    <h5
                      className="text-left"
                      style={{ marginLeft: "14px", fontSize: "16px" }}
                    >
                      {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.name ? OrderDetail?.order_addresses?.[0]?.contractors_address?.name : "-"}`}
                    </h5>
                    <p className="text-left" style={{ marginLeft: "14px" }}>
                      <small style={{ fontSize: "90%" }}>
                        {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.contact_person ? OrderDetail?.order_addresses?.[0]?.contractors_address?.contact_person : "-"}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[0]?.contractors_address?.address)}`}
                        {/* {`${}`} */}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(formatToNumber(
                          OrderDetail?.order_addresses?.[0]?.contractors_address
                            ?.phone
                        ))}`}
                      </small>
                      <br></br>
                      <small style={{ fontSize: "85%", color: "#000000DE" }}>
                        {`${checkUndefinedOrNull(OrderDetail?.order_addresses?.[0]?.contractors_address?.email)}`}
                        {/* {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.email}`} */}
                      </small>
                    </p>
                  </Col>
                </Row>


                <Row>
                  <Col xl={24}></Col>
                  <Divider />
                </Row>
                {/* {OrderDetail?.order_note && (
              <Row>
                <Col xl={24}>
                  <h3 className="text-left orderdetail-heading">
                    Order Checkout Note
                  </h3>
                </Col>
                <Col xl={24}>
                  <div
                    className="checkout-note"
                    style={{ height: this.state.isReadMore ? "auto" : "3rem" }}
                  >
                    {OrderDetail.order_note}
                  </div>
                  {OrderDetail.order_note.length > 150 ? (
                    <p
                      className="st-primary text-left pointer-cursor"
                      onClick={() =>
                        this.setState({
                          isReadMore: !this.state.isReadMore,
                        })
                      }
                    >
                      {this.state.isReadMore ? "READ LESS" : "READ MORE"}
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            )} */}

                {/* <Row style={{ marginTop: "10px" }}>
                  <Col span={24}>
                    <h3 className="text-left orderdetail-heading">
                      MEDIA ADDED
                    </h3>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-around">
                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#5C6BC0" }}
                      >
                        <MdAudiotrack color="white" size="20" />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#2196F3" }}
                      >
                        <AiOutlinePlaySquare
                          color="white"
                          size="20"
                          onClick={() =>
                            meta_asset.audios &&
                            this.setState({
                              isVisibleVideo: true,
                            })
                          }
                        />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#4CAF50" }}
                      >
                        <MdNote
                          color="white"
                          size="20"
                          onClick={() =>
                            OrderDetail?.note &&
                            this.setState({
                              isOpenNotesModal: true,
                            })
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-around">
                      <Col
                        span={8}
                        className="pointer-cursor text-center"
                        onClick={() => {
                          meta_asset.audios &&
                            this.setState({
                              isVisibleAudio: true,
                            });
                        }}
                      >
                        <small className="small">
                          {meta_asset.audios} Audios
                        </small>
                      </Col>
                      <Col
                        span={8}
                        className="pointer-cursor text-center"
                        onClick={() => {
                          meta_asset.videos &&
                            this.setState({
                              isVisibleVideo: true,
                            });
                        }}
                      >
                        <small className="small">
                          {meta_asset.videos} Videos
                        </small>
                      </Col>
                      <Col
                        span={8}
                        className="pointer-cursor text-center"
                        onClick={() =>
                          OrderDetail?.note &&
                          this.setState({
                            isOpenNotesModal: true,
                          })
                        }
                      >
                        <small className="small">Notes</small>
                      </Col>
                    </Row>
                    <Row justify="space-around" style={{ marginTop: "1rem" }}>
                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#E91E63" }}
                      >
                        <FaImages color="white" size="20" />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#FF9F00" }}
                      >
                        <BiNote
                          color="white"
                          size="20"
                          onClick={() =>
                            this.setState({
                              documentModal: true,
                            })
                          }
                        />
                      </Col>

                      <Col
                        className="contractor-avatar pointer-cursor text-center"
                        style={{ background: "#01D1FE" }}
                      >
                        <GrTest
                          color="white"
                          size="20"
                          onClick={() =>
                            this.setState({
                              documentModal: true,
                              isTesting: true,
                            })
                          }
                        />
                      </Col>
                      <Col xl={24} xs={24} sm={24} md={24} lg={24}>
                        <Row justify="space-around">
                          <Col
                            span={8}
                            className="pointer-cursor text-center"
                            onClick={() =>
                              meta_asset.images &&
                              this.setState({ isVisible: true })
                            }
                          >
                            <small className="small">
                              {meta_asset.images} Images
                            </small>
                          </Col>
                          <Col
                            span={8}
                            className="pointer-cursor text-center"
                            onClick={() =>
                              this.setState({
                                documentModal: true,
                              })
                            }
                          >
                            <small className="small">
                              {meta_asset?.documents} Files
                            </small>
                          </Col>
                          <Col
                            span={8}
                            className="pointer-cursor text-center"
                            onClick={() =>
                              this.setState({
                                documentModal: true,
                                isTesting: true,
                              })
                            }
                          >
                            <small className="small">
                              {meta_asset?.test_documents} Testing
                            </small>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
              </OrderNumWrapper>
            </Col>
            <Col xl={14} md={24} lg={13} xs={24} sm={24}>
              <OrderNumWrapper>
                <Row
                  gutter={[0, 10]}
                  style={{ marginBottom: "10px", marginTop: "10px" }}
                >
                  <Col xl={18} lg={18} md={18}>
                    <h5 className="text-left">Order Details</h5>
                  </Col>
                  {OrderDetail?.driver_orders?.user && (
                    <>
                      <Col span={5} className="text-right">
                        <h3
                          style={{ fontWeight: "720", fontSize: "0.6rem" }}
                          className="text-left"
                        >
                          {OrderDetail?.driver_orders?.user && "DRIVER"}
                        </h3>
                        <h3
                          className="text-left"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {`${OrderDetail?.driver_orders?.user?.first_name} ${OrderDetail?.driver_orders?.user?.last_name}`}
                        </h3>
                      </Col>
                    </>
                  )}
                  <Col span={24} style={{ marginTop: "12px" }}>
                    <Row
                      className="ordertable-heading"
                      style={{ height: "40px" }}
                      align="middle"
                    >
                      <Col span={12} xl={11} xs={10} className="text-left">
                        <span
                          className="text-left color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          PRODUCT
                        </span>
                      </Col>
                      <Col span={4} xs={9}>
                        <span
                          className="color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          QUANTITY
                        </span>
                      </Col>
                      <Col
                        span={6}
                        xs={4}
                        className="text-left color-light-grey"
                        style={{
                          textTransform: "uppercase",
                          color: "#9b9ea4",
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        <span className="color-light-grey">ACTION</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                { }
                {OrderDetail?.order_products?.length ? (
                  (OrderDetail?.order_products || []).map((item) => {
                    let total_amount = item?.order_product_additives?.filter(
                      (v) => {
                        return v.selected;
                      }
                    );
                    let p = 0;
                    let c = (total_amount || []).map((d) => {
                      p = p + Number(d.rmx_product_additive.price);
                      return p;
                    });
                    return (
                      <Row
                        style={{
                          paddingBottom: "10px",
                          borderBottom: "1px solid #d0d0d0 ",
                          alignItems: "baseline"
                        }}
                      >
                        <Col span={12}>
                          <Row gutter={[10, 0]}>
                            <Col className="text-left">
                              <img
                                width={"52px"}
                                height={"52px"}
                                src={item?.rmx_product?.image?.medium}
                              />
                            </Col>
                            <Col
                              xl={12}
                              xs={24}
                              sm={24}
                              md={20}
                              lg={14}
                              className="text-left"
                              style={{ paddingTop: "12px" }}
                            >
                              <p>{item?.rmx_product?.name}</p>
                              {/* <br /> */}
                              {/* <span>{`$${
                          item?.rmx_product?.price
                            ? item?.rmx_product?.price
                            : ""
                        }/${item?.rmx_product?.unit}`}</span> */}
                              {/* <br /> */}
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6} style={{ paddingTop: "15px" }}>
                          <p>{`${item?.quantity} CY`} </p>
                        </Col>
                        <Col span={6} style={{ paddingTop: "15px" }}>
                          <p
                            className="view-link pointer-cursor"
                            onClick={() =>
                              this.setState({
                                isOpenViewMix: true,
                                orderViewMix: item.order_product_additives,
                                viewMixDetail: item,
                              })
                            }
                            style={{ fontSize: "0.70rem" }}
                          >
                            VIEW MIX
                          </p>
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <Row>
                    <Col
                      className="text-left"
                      span={24}
                      style={{
                        borderBottom: "1px solid #d0d0d0 ",
                        paddingBottom: "10px",
                        paddingTop: "10px",
                        paddingLeft: "10px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "16px",
                          color: "d0d0d0 ",
                        }}
                      >
                        No records found
                      </span>
                    </Col>
                  </Row>
                )}


              </OrderNumWrapper>

              <OrderNumWrapper
                // style={{
                //   marginTop: 10,
                //   // overflowY: "scroll", overflowX: "hidden",
                //   height: "auto",
                // }}
                className={OrderDetail?.driver_orders?.length > 2 ? "details-scroll" : ""}
              >
                <Row>
                  <Col span={18} lg={20}>
                    <h5 className="text-left">Driver Details</h5>
                  </Col>
                  <Col span={24}>
                    <Row
                      className="ordertable-heading"
                      style={{ height: "40px" }}
                      align="middle"
                    >
                      <Col span={12} className="text-left">
                        <span
                          className="text-left color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          NAME
                        </span>
                      </Col>
                      <Col span={12} className="text-left">
                        <span
                          className="color-light-grey"
                          style={{
                            textTransform: "uppercase",
                            color: "#9b9ea4",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          MEDIA DETAILS
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  <Row style={{ width: "100%", marginTop: 20 }}
                    className={OrderDetail?.driver_orders?.length > 2 ? "media-height" : ""}
                  >
                    {OrderDetail?.driver_orders?.map((item, index) => {
                      return (
                        <>
                          <Col
                            xl={8}
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: 2,
                              marginTop: 10,
                              wordBreak: "break-all",
                              borderBottom: "1px solid rgb(208, 208, 208)",
                            }}
                          >
                            {!OrderDetail?.driver_orders ? (
                              <span style={{ paddingLeft: 20 }}>-----</span>
                            ) : (
                              <span style={{ display: "flex", alignItems: "center" }}>
                                {/* {OrderDetail?.driver_orders?.user?.first_name}{" "}
                                {OrderDetail?.driver_orders?.user?.last_name} */}
                                {

                                  OrderDetail?.driver_orders[index]?.is_lead == true ?
                                    <> <CgCrown size="30px" />
                                      <span style={{ display: "flex", alignItems: "center", marginLeft: '5px', fontWeight: "bold" }}> {OrderDetail?.driver_orders[index]?.user?.first_name} {OrderDetail?.driver_orders[index]?.user?.last_name}</span> </>
                                    : <> {OrderDetail?.driver_orders[index]?.user?.first_name} {OrderDetail?.driver_orders[index]?.user?.last_name} </>
                                }
                              </span>
                            )}
                          </Col>
                          <Col
                            xl={16}
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            style={{
                              borderBottom: "1px solid rgb(208, 208, 208)",
                              marginTop: 10,
                            }}
                          >
                            <Col span={24}>
                              <Row justify="space-around">


                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#4CAF50" }}
                                    >
                                      <FileOutlined
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          // (OrderDetail?.note || []).map((itm) => {

                                          if (item?.note) {
                                            this.setState({
                                              // assestDriverId: item?.user.id,
                                              noteShowOnModal: item?.note,
                                              isOpenNotesModal: true

                                            });
                                          }
                                          // })
                                        }
                                        }
                                      />
                                    </Col>
                                    <Col className="pointer-cursor text-center"
                                      onClick={() => {
                                        // (OrderDetail?.note || []).map((itm) => {

                                        if (item?.note) {
                                          this.setState({
                                            // assestDriverId: item.user.id,
                                            noteShowOnModal: item?.note,
                                            isOpenNotesModal: true

                                          });
                                        }
                                        // })
                                      }}

                                    >
                                      <div style={{ display: "none" }}>
                                        {
                                          item?.note != null ? ++assetsCount : assetsCount = 0
                                        }
                                      </div>

                                      {/* {
                                        (OrderDetail?.note || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      } */}
                                      <small
                                        className="small"
                                      >
                                        {assetsCount} Notes
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#5C6BC0" }}
                                      onClick={() => {
                                        if (OrderDetail?.meta_asset?.audios > 0) {

                                          (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {
                                              this.setState({
                                                assestDriverId: item.user.id,
                                                isVisibleVideo: true

                                              });
                                            }
                                          })
                                        }
                                      }}
                                    >
                                      <MdAudiotrack color="white" size="20" />
                                    </Col>
                                    <Col
                                      // span={3}
                                      // style={{ marginTop: 20 }}
                                      className="pointer-cursor text-center"
                                      onClick={() => {

                                        (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            this.setState({
                                              assestDriverId: item.user.id,
                                              isVisibleAudio: true

                                            });
                                          }
                                        })
                                      }}
                                    >
                                      {
                                        (OrderDetail?.order_assets?.audios || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Audios
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#2196F3" }}
                                    >
                                      <AiOutlinePlaySquare
                                        color="white"
                                        size="20"
                                        onClick={() => {
                                          if (OrderDetail?.meta_asset?.videos > 0) {

                                            (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                              if (itm.userable_id == item.user.id) {
                                                this.setState({
                                                  assestDriverId: item.user.id,
                                                  isVisibleVideo: true

                                                });
                                              }
                                            })
                                          }
                                        }}
                                      />
                                    </Col>
                                    <Col className="pointer-cursor text-center"
                                      onClick={() => {
                                        (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            this.setState({
                                              assestDriverId: item.user.id,
                                              isVisibleVideo: true

                                            });
                                          }
                                        })
                                      }}

                                    >
                                      {
                                        (OrderDetail?.order_assets?.videos || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small
                                        className="small"
                                      >
                                        {assetsCount} Videos
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center  "
                                      style={{ background: "#E91E63" }}
                                    >
                                      <FaImages
                                        color="white"
                                        size="20"
                                        onClick={() => {

                                          {
                                            (OrderDetail?.order_assets?.images || []).map((itm) => {

                                              if (itm.userable_id == item.user.id) {
                                                if (OrderDetail.meta_asset.images > 0) {
                                                  this.setState({ assestDriverId: item.user.id, isVisible: true });
                                                }
                                              }
                                            })
                                          }
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() => {
                                        {
                                          (OrderDetail?.order_assets?.images || []).map((itm) => {

                                            if (itm.userable_id == item.user.id) {

                                              if (OrderDetail.meta_asset.images > 0) {

                                                this.setState({ assestDriverId: item.user.id, isVisible: true });
                                              }
                                            }
                                          })
                                        }
                                      }}
                                    >
                                      {
                                        (OrderDetail?.order_assets?.images || []).map((itm) => {

                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }

                                      <small className="small">
                                        {assetsCount} Images
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>


                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor text-center"
                                      style={{ background: "#FF9F00" }}
                                    >
                                      <BiNote
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            // fileDocument: true,
                                            assestDriverId: item.user.id,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() =>
                                        this.setState({
                                          documentModal: true,
                                          // fileDocument: true,
                                          assestDriverId: item.user.id,
                                        })
                                      }
                                    >
                                      {
                                        (OrderDetail?.order_assets?.documents || []).map((itm) => {
                                          console.log("looooo count", item.userable_id, item.user.id);
                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Files
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>

                                {/* <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor"
                                      style={{ background: "#01D1FE" }}
                                    >
                                      <GrTest
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            testFileDocument: true,
                                            isTesting: true,
                                            assestDriverId: item.user.id,
                                          })
                                        }
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() =>
                                        this.setState({
                                          testFileDocument: true,
                                          isTesting: true,
                                          assestDriverId: item.user.id,
                                        })
                                      }
                                    >
                                      {
                                        (OrderDetail?.order_assets?.test_documents || []).map((itm) => {
                                          if (itm.userable_id == item.user.id) {
                                            ++assetsCount
                                          }
                                        })
                                      }
                                      <small className="small">
                                        {assetsCount} Testing
                                      </small>
                                      <div style={{ display: "none" }}>
                                        {
                                          assetsCount = 0
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Col> */}

                                <Col>
                                  <Row style={{ display: "inline" }}>
                                    <Col
                                      className="contractor-avatar pointer-cursor"
                                      style={{ background: "#ff9800" }}
                                    >
                                      {/* <GrTest
                                        color="white"
                                        size="20"
                                        onClick={() =>
                                          this.setState({
                                            documentModal: true,
                                            isTesting: true,
                                          })
                                        }
                                      /> */}
                                      <img
                                        src={Distance}
                                        width={30}
                                        height={30}
                                        onClick={() => {
                                          // console.log("ddfdfdsfsdfsf", OrderDetail?.driver_orders[index]?.end_lat);
                                          // if (typeof (item?.distance) == "number") {
                                          this.setState({
                                            distanceModal: true,
                                            isDistance: true,
                                            assestDriverId: item.user.id
                                          });
                                          // }
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      className="pointer-cursor text-center"
                                      onClick={() => {
                                        // if (typeof (item?.distance) == "number") {
                                        this.setState({
                                          distanceModal: true,
                                          isDistance: true,
                                          assestDriverId: item.user.id
                                        });
                                        // }
                                      }}
                                    >
                                      <small className="small">
                                        {getMiles(item?.distance).toFixed(
                                          2
                                        )}
                                        mi
                                      </small>
                                    </Col>
                                  </Row>
                                </Col>

                              </Row>
                            </Col>
                          </Col>
                        </>
                      );
                    })}
                  </Row>
                </Row>
              </OrderNumWrapper>

              {/* <Row style={{ border: "solid 1px lightgrey", marginTop: "1rem" }}>
            <Col xl={10} sm={24} xs={24} md={24}>
              <CreditCard
                cardStyle={{
                  color: "black",
                  fontSize: "15px",
                  width: "100%",
                }}
                shipVisaStyling={true}
                paidText={true}
                cards={[]}
                fromOrder={true}
                data={OrderDetail?.order_stripe_charge?.charge}
              />
            </Col>
            <Col span={24} xl={12} lg={24} style={{ marginTop: "0.6rem" }}>
              <Row justify="space-between">
                <Col span={12} className="text-left">
                  Subtotal
                </Col>
                <Col span={12} className="text-right">
                  <p
                    style={{ fontWeight: "500" }}
                  >{`$${OrderDetail?.subtotal_amount}`}</p>
                </Col>
              </Row>
              <Row style={{ marginTop: "0.4rem" }}>
                <Col span={12} className="text-left">
                  Shipping & Handling
                </Col>
                <Col span={12} className="text-right">
                  <p
                    style={{ fontWeight: "500" }}
                  >{`$${OrderDetail?.shipping_amount}`}</p>
                </Col>
              </Row>
              <Row style={{ marginTop: "0.4rem" }}>
                <Col span={12} className="text-left">
                  Tax
                </Col>
                <Col span={12} className="text-right">
                  <p
                    style={{ fontWeight: "500" }}
                  >{`$${OrderDetail?.tax_amount}`}</p>
                </Col>
              </Row>
              <Row style={{ marginTop: "0.4rem" }}>
                <Col span={12} className="text-left">
                  <strong>Grand Total</strong>
                </Col>
                <Col span={12} className="text-right">
                  <strong
                    style={{ color: "#31A99E" }}
                    className="text-right"
                  >{`$${OrderDetail?.total_amount}`}</strong>
                </Col>
              </Row>
            </Col>
          </Row> */}
              {/* <Row justify="end" style={{ marginTop: "1rem" }}>
            {OrderDetail.status == 2 && (
              <>
                <Col xl={4}>
                  <Button
                    style={{
                      backgroundColor: "#31A99E",
                      color: "#fff",
                      width: "100%",
                    }}
                    onClick={() =>
                      this.setState({
                        isOpenReject: true,
                      })
                    }
                  >
                    REJECT
                  </Button>
                </Col>
                <Col xl={4}>
                  <Button
                    style={{
                      backgroundColor: "#FF9800",
                      color: "#fff",
                      width: "100%",
                    }}
                    onClick={() =>
                      this.setState({
                        Notes: true,
                      })
                    }
                  >
                    ACCEPT
                  </Button>
                </Col>
              </>
            )}
            {OrderDetail.status == 4 && (
              <Col xl={4}>
                <Button
                  style={{
                    backgroundColor: "#FF9800",
                    color: "#fff",
                    width: "100%",
                  }}
                  onClick={() => {
                    this.setState({
                      isDispatchModal: true,
                    });
                    this.props.getLogisticsReq();
                    this.props.getLogPartnerReq();
                  }}
                >
                  Dispatch
                </Button>
              </Col>
            )}
          </Row> */}
            </Col>


            {/* individual testdocument modal */}
            {/* <CustomModal
              visible={this.state.testFileDocument}
              onCancelModal={() =>
                this.setState({
                  testFileDocument: false,
                  isTesting: false,
                  assestDriverId: ""
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  ></Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {"TEST FILES"}
                  </h3>
                </Col>

                {(OrderDetail?.order_assets?.test_documents || []
                ).map((item) => {
                  if (item.userable_id == this.state.assestDriverId) {
                    return (
                      <FileView
                        item={item}
                        orderId={OrderDetail.id}
                        {...this.props}
                        isTesting={this.state.isTesting}
                      />

                    );
                  }
                })}

                {OrderDetail?.order_assets?.test_documents?.length === 0 && (
                  <Col
                    span={12}
                    style={{
                      textAlign: "center",
                      margin: "25%",
                      color: "grey",
                    }}
                  >
                    <span>Nothing to show right now</span>
                  </Col>
                )}
              </Row>
            </CustomModal> */}



            {/* individual document modal */}
            {/* <CustomModal
              visible={this.state.fileDocument}
              onCancelModal={() =>
                this.setState({
                  fileDocument: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  ></Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {"FILES"}
                  </h3>
                </Col>

                {
                  (OrderDetail?.order_assets?.documents || []
                  ).map((item) => {
                    if (item.userable_id == this.state.assestDriverId) {
                      return (
                        <FileView
                          item={item}
                          orderId={OrderDetail.id}
                          {...this.props}
                          isTesting={this.state.isTesting}
                        />

                      );
                    }
                  })}
                {OrderDetail?.order_assets?.documents?.length === 0 && (
                  <Col
                    span={12}
                    style={{
                      textAlign: "center",
                      margin: "25%",
                      color: "grey",
                    }}
                  >
                    <span>Nothing to show right now</span>
                  </Col>
                )}

              </Row>
            </CustomModal> */}



            {/* logistic FileModal */}
            <CustomModal
              visible={this.state.isOpenLogisticsFileModal}
              onCancelModal={() =>
                this.setState({
                  isOpenLogisticsFileModal: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {/* <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => inputRef.click()}
                    >
                      Upload
                    </Button> */}
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {this.state.isTesting ? "TEST" : "FILES"}
                  </h3>
                </Col>
                {(this.state.isTesting
                  ? OrderDetail?.order_assets?.test_documents
                  : orderDetailDocument || []
                ).map((item) => {
                  return (
                    <FileView
                      item={item}
                      orderId={OrderDetail.id}
                      {...this.props}
                      isTesting={this.state.isTesting}
                    />
                  );
                })}
                {OrderDetail?.order_assets?.documents?.length === 0 &&
                  !this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
                {OrderDetail?.order_assets?.test_documents?.length === 0 &&
                  !!this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
              </Row>
            </CustomModal>


            {/* logistic TestModal */}
            <CustomModal
              visible={this.state.isOpenLogisticsTestsModal}
              onCancelModal={() =>
                this.setState({
                  isOpenLogisticsTestsModal: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {/* <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => inputRef.click()}
                    >
                      Upload
                    </Button> */}
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {this.state.isTesting ? "TEST" : "FILES"}
                  </h3>
                </Col>
                {(this.state.isTesting
                  ? orderDetailTestDocument
                  : OrderDetail?.order_assets?.documents || []
                ).map((item) => {
                  return (
                    <FileView
                      item={item}
                      orderId={OrderDetail.id}
                      {...this.props}
                      isTesting={this.state.isTesting}
                    />
                  );
                })}
                {OrderDetail?.order_assets?.documents?.length === 0 &&
                  !this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
                {OrderDetail?.order_assets?.test_documents?.length === 0 &&
                  !!this.state.isTesting && (
                    <Col
                      span={12}
                      style={{
                        textAlign: "center",
                        margin: "25%",
                        color: "grey",
                      }}
                    >
                      <span>Nothing to show right now</span>
                    </Col>
                  )}
              </Row>
            </CustomModal>


            {/* logistics Notemodal */}
            <CustomModal
              visible={this.state.isOpenLogisticsNotesModal}
              onCancelModal={() =>
                this.setState({
                  isOpenLogisticsNotesModal: false,
                  assestDriverId: "",
                  noteShowOnModal: ""
                })
              }
              footer={[
                <Row justify="start" style={{ margin: "20px" }}>
                  <Col
                    span={24}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      NOTES
                    </h6>
                  </Col>
                  <Col
                    span={24}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <span className="text-left">{OrderDetail?.note}</span>
                  </Col>
                </Row>,
              ]}
            >

            </CustomModal>





            <CustomModal
              visible={this.state.documentModal}
              onCancelModal={() =>
                this.setState({
                  documentModal: false,
                  isTesting: false,
                })
              }
              width={800}
              className="file-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  ></Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h3 className="text-left" style={{ color: "grey" }}>
                    {this.state.isTesting ? "TEST" : "FILES"}
                  </h3>
                </Col>
                {(this.state.isTesting
                  ? OrderDetail?.order_assets?.test_documents
                  : OrderDetail?.order_assets?.documents || []
                ).map((item) => {

                  if (item.userable_id == this.state.assestDriverId) {
                    return (
                      <FileView
                        item={item}
                        orderId={OrderDetail.id}
                        {...this.props}
                        isTesting={this.state.isTesting}
                      />
                    );
                  }
                })}

                {OrderDetail?.order_assets?.documents?.length === 0 && (
                  <Col
                    span={12}
                    style={{
                      textAlign: "center",
                      margin: "25%",
                      color: "grey",
                    }}
                  >
                    <span>Nothing to show right now</span>
                  </Col>
                )}
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isDispatchModal}
              onCancelModal={() =>
                this.setState({
                  isDispatchModal: false,
                })
              }
              width={600}
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#31A99E",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => {
                        approvedOrder(
                          OrderDetail.id,
                          () => {
                            this.onCancelModal();
                            this.props.history.push("/dashboard");
                          },
                          "dispatch",
                          this.state.logValue
                        );
                      }}
                    >
                      Dispatch
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h2 className="text-center st-primary">Dispatch</h2>
                </Col>
                <Col
                  xl={24}
                  className="select-categories"
                  style={{ height: "50%" }}
                >
                  <Select
                    className="custom ant-select-selector"
                    style={{ height: "100%" }}
                    size="large"
                    placeholder="Select logistics partner"
                    name="basemix_category_id"
                    onChange={(e) =>
                      this.setState({
                        logValue: e,
                      })
                    }
                  // onSelect={() =>
                  //   this.setState({
                  //     isSelect: true,
                  //   })
                  // }
                  // open={!this.state.isSelect}
                  // onFocus={() =>
                  //   this.setState({
                  //     isSelect: false,
                  //   })
                  // }
                  >
                    {logistics.map((item) => {
                      return (
                        <Option value={item.id}>
                          <div
                            className="text-left"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <img
                              src={item.users?.[0]?.image?.original}
                              height={"50"}
                              width={"50"}
                              style={{ borderRadius: "50%" }}
                            />

                            {item?.business_name}

                            <AiFillStar
                              color={item.favourite ? "#F9A01B" : "grey"}
                              size="25"
                              onClick={() => this.props.markAsFav(item.id)}
                            />
                          </div>
                        </Option>
                      );
                    })}
                  </Select>
                </Col>
                <ul id="scroller">
                  {(this.props.log_partner || []).map((item) => {
                    return (
                      <li>
                        <span span={4}>
                          <img
                            src={item.users?.[0]?.image?.original}
                            height={"50"}
                            width={"50"}
                            style={{ borderRadius: "50%" }}
                          />
                        </span>
                        <span span={24}>
                          <p className="three-dot">
                            {item.users?.[0]?.first_name}{" "}
                            {item.users?.[0]?.last_name}
                          </p>{" "}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isOpenNotesModal}
              onCancelModal={() =>
                OrderDetail?.note &&
                this.setState({
                  isOpenNotesModal: false,
                })
              }
              footer={[
                <Row justify="start" style={{ margin: "20px" }}>
                  <Col
                    span={24}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      NOTES
                    </h6>
                  </Col>
                  <Col
                    span={24}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <span className="text-left">{OrderDetail?.note}</span>
                  </Col>
                </Row>,
              ]}
            ></CustomModal>

            <CustomModal
              visible={this.state.Notes}
              onCancelModal={this.onCancelModal}
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#26a69a ",
                        color: "#fff",
                        width: "50%",
                        border: "none",
                      }}
                      onClick={() => {
                        this.setState({
                          isDispatchModal: true,
                        });
                        this.props.getLogisticsReq();
                        this.props.getLogPartnerReq();
                      }}
                    >
                      ACCEPT & DISPATCH
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        approvedOrder(
                          OrderDetail.id,
                          () => {
                            this.onCancelModal();
                            this.props.history.push("/dashboard");
                          },
                          "approval"
                        )
                      }
                    >
                      APPROVE
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col className="d-flex justify-content-center" span={24}>
                  <h1 className="st-primary">Approve Order</h1>
                </Col>
                <Col span={12} style={{ textAlign: "center" }}>
                  <span>Are you sure you want to approve this order?</span>
                </Col>
              </Row>
            </CustomModal>
            <CustomModal
              visible={this.state.isOpenReject}
              onCancelModal={() =>
                this.setState({
                  isOpenReject: false,
                })
              }
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        approvedOrder(
                          OrderDetail.id,
                          () => {
                            this.setState({
                              isOpenReject: false,
                            });
                            this.props.history.push("/dashboard");
                          },
                          "reject"
                        )
                      }
                    >
                      YES
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#26a69a ",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.setState({
                          isOpenReject: false,
                        })
                      }
                    >
                      NO
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col className="d-flex justify-content-center" span={24}>
                  <img src={Delete_order} />
                </Col>
                <Col span={12} style={{ textAlign: "center" }}>
                  <span>Are you sure you want to reject this order?</span>
                </Col>
              </Row>
            </CustomModal>
            <input
              type="file"
              ref={(ref) => (inputRef = ref)}
              accept=".docx,.pdf"
              className="d-none"
              onChange={(e) => {
                this.props.uploadDocReq(
                  OrderDetail.id,
                  {
                    attachment: e.target.files[0],
                    file: e.target.files[0],
                    uploader_user_id: this.props?.user?.[0]?.user?.id,
                  },
                  {
                    params: this.state.isTesting
                      ? "test_documents"
                      : "documents",
                  }
                );
              }}
            />

            <CustomModal
              visible={this.state.isOpenViewMix}
              onCancelModal={() =>
                this.setState({
                  isOpenViewMix: false,
                })
              }
              className="view-mix-modal"
              width={700}
              footer={[
                <Row justify="end">
                  <Col span={24} style={{ width: "100%" }}>
                    <Button
                      style={{
                        backgroundColor: "#ff9800 ",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.setState({
                          isOpenViewMix: false,
                        })
                      }
                    >
                      Close
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row
                justify="center"
                style={{ marginBottom: "30px" }}
                gutter={[10, 0]}
              >
                <Col>
                  <span className="modal-headning st-primary">
                    {viewMixDetail?.rmx_product?.name}
                    {/* {OrderDetail?.order_products?.[0]?.rmx_product?.name} */}
                  </span>
                </Col>

                <Divider />
              </Row>
              <Row>
                <Col span={9}>
                  <img
                    src={viewMixDetail?.rmx_product?.image?.medium}
                    style={{ objectFit: "contain", width: "90%" }}
                  />
                </Col>
                <Col
                  span={14}
                  style={{ border: "1px solid #F0F0F0", padding: "0.5rem" }}
                >
                  <Row>
                    <Col span={12} style={{ position: "relative" }}>
                      <img
                        src={Configuration}
                        style={{
                          width: "100%",
                          position: "absolute",
                          backgroundRepeat: "no-repeat",
                          top: "-20px",
                          zIndex: 1000,
                        }}
                      />
                    </Col>
                    {!!filterViewMix.length ? (
                      <Col
                        span={24}
                        style={{
                          height: "8rem",
                          overflowY: "auto",
                          overflowX: "hidden",
                          margin: "5px",
                        }}
                      >
                        {filterViewMix.map((item) => {
                          return (
                            <p style={{ marginTop: "35px" }}>
                              {item?.rmx_product_additive?.name}
                            </p>
                          );
                        })}

                        {/* {OrderDetail?.order_products?.order_product_additives.map()(
                    (item) => {
                      console.log("itemmss==>", item);
                      return (
                        <p style={{ marginTop: "35px" }}>
                          {item?.rmx_product_additive?.name}
                        </p>
                      );
                    }
                  )} */}
                      </Col>
                    ) : (
                      <Col span={24} style={{ margin: "3.5rem" }}>
                        <span
                          style={{
                            margin: "auto",
                            color: "#e0e0e0",
                            textAlign: "center",
                            fontSize: "16px",
                          }}
                        >
                          Nothing to show right now.
                        </span>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </CustomModal>
            <CustomModal
              visible={isOpenCheckList}
              onCancelModal={() =>
                this.setState({
                  isOpenCheckList: false,
                })
              }
              closable={false}
              width={500}
              className="checklist-modal"
              footer={[
                <Row justify="center" style={{ margin: "20px" }}>
                  <Col
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "lightgrey",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.setState({
                          isOpenCheckList: false,
                        })
                      }
                    >
                      Close
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col span={24}>
                  <h2 className="text-center st-primary">
                    {this.state.checkListData[listIndex]?.title}
                  </h2>
                  <Divider />
                </Col>
                {(this.state.checkListData[listIndex]?.question || []).map(
                  (v) => {
                    return (
                      <Col span={24} style={{ margin: "0.5rem" }}>
                        <input type="checkbox" class="c2" checked={v.value} />

                        <span className="text-left" style={{ margin: "1rem" }}>
                          {v.name}
                        </span>
                      </Col>
                    );
                  }
                )}
              </Row>
              {checklistAction === "drop_order" && (
                <Row justify="center" style={{ marginTop: "3rem" }}>
                  <Col span={1}>
                    {" "}
                    <BsCircleFill
                      color={listIndex === 0 ? "#4CAF50" : "#E0E0E0"}
                      className="pointer-cursor"
                      onClick={() => this.setState({ listIndex: 0 })}
                    />{" "}
                  </Col>
                  <Col span={1}>
                    {" "}
                    <BsCircleFill
                      color={listIndex === 1 ? "#4CAF50" : "#E0E0E0"}
                      className="pointer-cursor"
                      onClick={() => this.setState({ listIndex: 1 })}
                    />{" "}
                  </Col>
                </Row>
              )}
            </CustomModal>
            <div style={{ display: "none" }}>
              <Image.PreviewGroup
                preview={{
                  visible: this.state.isVisible,
                  onVisibleChange: (vis) =>
                    this.setState({
                      isVisible: vis,
                      assestDriverId: ""
                    }),
                }}
              >
                {(OrderDetail?.order_assets?.images || []).map((item) => {

                  if (item.userable_id == this.state.assestDriverId) {

                    return <Image src={item?.attachment?.original} />;
                  }
                })}
              </Image.PreviewGroup>
            </div>

            <CustomModal
              visible={this.state.isVisibleVideo}
              onCancelModal={() =>
                this.setState({
                  isVisibleVideo: false,
                  assestDriverId: ""

                })
              }
              width={700}
              footer={[
                <Col span={24}>
                  <Row justify="center">
                    {(OrderDetail?.order_assets?.videos || []).map(
                      (item, index) => {
                        return (
                          <Col
                            span={2}
                            className="pointer-cursor d-flex justify-content-center"
                            onClick={() => {
                              this.setState({
                                videoIndex: index,
                                attachment:
                                  OrderDetail?.order_assets?.videos?.[index]
                                    ?.attachment,
                              });
                            }}
                          >
                            <BsFillCameraReelsFill
                              size="25"
                              color={index == videoIndex ? "grey" : "black"}
                            />
                          </Col>
                        );
                      }
                    )}
                  </Row>
                </Col>,
              ]}
            >
              <Row justify="center">
                <Col span={24} className="d-flex justify-content-center">
                  <ReactPlayer
                    controls
                    url={
                      OrderDetail?.order_assets?.videos?.[videoIndex]
                        ?.attachment
                    }
                    height={250}
                    playing={this.state.isVisibleVideo}
                  />
                </Col>
              </Row>
            </CustomModal>

            <CustomModal
              visible={this.state.isVisibleAudio}
              onCancelModal={() =>
                this.setState({
                  isVisibleAudio: false,
                  assestDriverId: ""
                })
              }
              width={700}
              footer={[
                <Col span={24}>
                  <Row justify="center">
                    {(OrderDetail?.order_assets?.audios || []).map(
                      (item, index) => {
                        if (item.userable_id == this.state.assestDriverId) {
                          return (
                            <Col
                              span={24}
                              className="pointer-cursor d-flex justify-content-center"
                              onClick={() => {
                                this.setState({
                                  audioIndex: index,
                                  attachment:
                                    OrderDetail?.order_assets?.audios?.[index]
                                      ?.attachment,
                                });
                              }}
                            >
                              <MdAudiotrack
                                size="25"
                                color={index == audioIndex ? "grey" : "black"}
                              />
                            </Col>
                          );
                        }
                      }
                    )}
                  </Row>
                </Col>,
              ]}
            >
              <Row justify="center">
                <Col span={24} className="d-flex justify-content-center">
                  <ReactPlayer
                    controls
                    url={
                      OrderDetail?.order_assets?.audios?.[audioIndex]
                        ?.attachment
                    }
                    height={250}
                    playing={isVisibleAudio}
                  />
                </Col>
              </Row>
            </CustomModal>
            <CustomModal
              visible={this.state.isOpenNotesModal}
              onCancelModal={() =>
                this.setState({
                  isOpenNotesModal: false,
                  assestDriverId: "",
                  noteShowOnModal: ""
                })
              }
              footer={[
                <Row justify="start" style={{ margin: "20px" }}>
                  <Col
                    span={24}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      NOTES
                    </h6>
                  </Col>
                  <Col
                    span={24}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <span className="text-left">{this.state.noteShowOnModal}</span>
                  </Col>
                </Row>,
              ]}
            ></CustomModal>
            <CustomModal
              className="distance-modal"
              visible={this.state.distanceModal}
              onCancelModal={() =>
                this.setState({
                  distanceModal: false,
                  assestDriverId: ""
                })
              }
              footer={[
                <Row justify="start" style={{ margin: "20px" }}>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      Starting Point:
                    </h6>
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >

                    {
                      OrderDetail?.driver_orders.map((itm, ind) => {
                        if (itm.user.id == this.state.assestDriverId) {
                          return <span className="text-left">
                            {`(${itm.start_lat ? itm.start_lat : "0.00"},${itm.start_long ? itm.start_long : "0.00"})`}
                          </span>
                        }
                      })

                    }


                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      Ending Point:
                    </h6>
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    {
                      OrderDetail?.driver_orders.map((itm, ind) => {
                        if (itm.user.id == this.state.assestDriverId) {
                          return <span className="text-left">
                            {`(${itm.end_lat ? itm.end_lat : "0.00"},${itm.end_long ? itm.end_long : "0.00"})`}
                          </span>
                        }
                      })

                    }
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    <h6
                      style={{ color: "#09c1b2", fontSize: "1rem" }}
                      className="text-left"
                    >
                      Distance Travelled
                    </h6>
                  </Col>
                  <Col
                    span={12}
                    className="d-flex text-left"
                    style={{ width: "100%" }}
                  >
                    {
                      OrderDetail?.driver_orders.map((itm, ind) => {
                        if (itm.user.id == this.state.assestDriverId) {
                          return <span className="text-left">
                            {getMiles(itm?.distance).toFixed(2)}
                            mi
                          </span>
                        }
                      })

                    }

                  </Col>
                </Row>,
              ]}
            ></CustomModal>
          </Row>
        ) : (
          <Row justify="center">
            <Col>
              {this.props.isLogisticsLoading && (
                <img src={LoaderGif} height={"60"} width={"60"} />
              )}
            </Col>
          </Row>
        )}
      </>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    OrderDetail: store.DashboardReducer.logisticDetail,
    user: store.AuthReducer.user,
    logistics: store.DashboardReducer.logistics,
    log_partner: store.DashboardReducer.log_partner,
    isLogisticsLoading: store.DashboardReducer.isLogisticLoading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLogisticDetail: (id, orderId) =>
      dispatch(DashboardAction.getLogisticDetailReq(id, orderId)),
    approvedOrder: (id, cb, params, logId) =>
      dispatch(DashboardAction.OrderApprovalReq(id, cb, params, logId)),
    deleteDocReq: (orderId, docId, cb) =>
      dispatch(DashboardAction.deleteDocReq(orderId, docId, cb)),
    uploadDocReq: (orderId, payload, cb) =>
      dispatch(DashboardAction.uploadDocReq(orderId, payload, cb)),
    getLogisticsReq: () => dispatch(DashboardAction.getLogisticsReq()),
    getLogPartnerReq: () => dispatch(DashboardAction.getLogPartnerReq()),
    markAsFav: (id) => dispatch(DashboardAction.markAsFavReq(id)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogisticsOrderDetail);
